// index.js (Vanilla JS version of former React index.jsx)
import { SliderCartAddons } from './SliderCartAddons.js';
import { SliderCartAddonsMobile } from './SliderCartAddonsMobile.js';

const viewports = {
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
};

function getViewport() {
  return window.innerWidth < 768 ? viewports.MOBILE : viewports.DESKTOP;
}

function handleCartDidUpdate() {
  try {
    const isEmpty = window.cart?.item_count <= 0;
    document
      .querySelectorAll('[data-cart-header-not-empty]')
      .forEach((el) => (el.style.display = isEmpty ? 'none' : 'block'));
    document
      .querySelectorAll('[data-cart-header-empty]')
      .forEach((el) => (el.style.display = isEmpty ? 'block' : 'none'));
  } catch (error) {
    console.log(error);
  }
}

function renderSliderCartAddOns(el, promoData, viewport) {
  const wrapper = document.createElement('div');
  wrapper.className = 'SliderCartAddOnsContainer';

  if (viewport === viewports.DESKTOP) {
    const content = SliderCartAddons({ promo: promoData });
    if (content) wrapper.appendChild(content);
  } else {
    const content = SliderCartAddonsMobile({ promo: promoData });
    if (content) wrapper.appendChild(content);
  }

  el.appendChild(wrapper);
}

function initializeSliderCartAddOns() {
  const elements = document.querySelectorAll('[data-slider-cart-add-ons]');
  if (elements.length === 0) return;

  const viewport = getViewport();

  elements.forEach((el) => {
    if (el.getAttribute('initialized') === 'true') return;
    el.setAttribute('initialized', 'true');

    const promoDataStr = decodeURIComponent(el.getAttribute('data-promo'));
    const promoData = JSON.parse(promoDataStr);
    renderSliderCartAddOns(el, promoData, viewport);
  });
}

// Bind cart event listeners
function bindCartEvents() {
  const sliderCartAddOns = document.querySelector('[data-cart-add-ons]');
  const sliderToggle = document.querySelector('[data-slider-cart-toggle]');
  const sliderClose = document.querySelector('[data-close-slider-cart]');
  const cart = document.querySelector('[data-cart]');

  document.addEventListener('cartDidOpen', () => {
    if (sliderCartAddOns) sliderCartAddOns.classList.add('SliderCartAddOns--open');
    handleCartDidUpdate();
  });

  document.addEventListener('menusWillClose', () => {
    if (sliderCartAddOns) {
      sliderCartAddOns.classList.remove('SliderCartAddOns--open');
      cart.classList.remove('SliderCart--collapsed');
      sliderCartAddOns.classList.remove('SliderCartAddOns--expand');
      sliderClose?.classList.remove('SliderCart__close-button--collapsed');
    }
  });

  if (sliderToggle) {
    sliderToggle.addEventListener('click', () => {
      sliderToggle.classList.toggle('SliderCart__toggle--flipped');
      cart.classList.toggle('SliderCart--collapsed');
      sliderCartAddOns.classList.toggle('SliderCartAddOns--expand');
      sliderClose.classList.toggle('SliderCart__close-button--collapsed');
    });
  }

  document.querySelectorAll('[data-cart-add-ons] [data-add-to-cart]').forEach((el) => {
    el.addEventListener('click', () => {
      if (!cart.classList.contains('SliderCart--collapsed')) return true;
      const currentBreakpoint = window.theme?.breakpoints?.current;
      if (currentBreakpoint === 'mobile' || currentBreakpoint === 'tablet') {
        sliderToggle?.click();
      }
      return true;
    });
  });
}

// Responsive rebinding
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const elements = document.querySelectorAll('[data-slider-cart-add-ons]');
    elements.forEach((el) => {
      const promoDataStr = decodeURIComponent(el.getAttribute('data-promo'));
      const promoData = JSON.parse(promoDataStr);
      renderSliderCartAddOns(el, promoData, getViewport());
    });
  }, 500);
});

export default function SliderCartAddOnsInit() {
  initializeSliderCartAddOns();
  bindCartEvents();
}
